import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Title } from 'src/app/shared/models/title.model';
import { ValidateImage } from 'src/app/shared/models/validate-image.model';

@Component({
  selector: 'app-validate-images-modal',
  templateUrl: './validate-images-modal.component.html',
  styleUrls: ['./validate-images-modal.component.scss']
})
export class ValidateImagesModalComponent implements OnInit {

  imageList: ValidateImage[];
  purposeForm: FormGroup;
  title: Title;

  @Input() paramList: ValidateImage[];
  @Input() paramTitle: Title;

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.purposeForm = this.formBuilder.group({
      isbn: [''],
      name: [''],
    });

    if (this.paramList) {
      this.imageList = this.paramList;
    }

    this.title = this.paramTitle;

    console.log(this.title);

    if( this.title)
    {
      this.purposeForm.patchValue({
        isbn: this.title.isbn,
        name: this.title.title
      });
    }
    else{
      this.purposeForm.patchValue({
        isbn: "No se encontro información",
        name: "No se encontro información"
      });
    }


  }

  close(): void {

    
    this.activeModal.close(this.purposeForm.value);
  }
}
